// extracted by mini-css-extract-plugin
export default {"container":"LongTermMedicationIcon_container__J5X7i","hidden":"LongTermMedicationIcon_hidden__UzOIK"};